// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file tournament/v1/tournament.proto (package tournament.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { TournamentLevelType } from "../../base/v1/tournament_level_pb.js";
import { TournamentDivisionType } from "../../base/v1/tournament_division_pb.js";
import { TournamentCategoryType } from "../../base/v1/tournament_category_pb.js";
import { Sport } from "../../base/v1/whiteboard_pb.js";
import { User } from "../../base/v1/user_pb.js";
import { TournamentRequestState } from "../../base/v1/tournament_request_state_pb.js";

/**
 * @generated from message tournament.v1.Tournament
 */
export const Tournament = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.Tournament",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "last_date_of_entry", kind: "message", T: Timestamp },
    { no: 6, name: "start_date", kind: "message", T: Timestamp },
    { no: 7, name: "end_date", kind: "message", T: Timestamp },
    { no: 8, name: "level", kind: "enum", T: proto3.getEnumType(TournamentLevelType) },
    { no: 9, name: "division", kind: "enum", T: proto3.getEnumType(TournamentDivisionType) },
    { no: 10, name: "categories", kind: "enum", T: proto3.getEnumType(TournamentCategoryType), repeated: true },
    { no: 11, name: "color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "participants", kind: "message", T: TournamentParticipant, repeated: true },
    { no: 13, name: "area", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "organiser", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "affiliated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "sport", kind: "enum", T: proto3.getEnumType(Sport) },
  ],
);

/**
 * @generated from message tournament.v1.TournamentParticipant
 */
export const TournamentParticipant = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.TournamentParticipant",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user", kind: "message", T: User },
    { no: 3, name: "created_at", kind: "message", T: Timestamp },
    { no: 4, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message tournament.v1.TournamentRequest
 */
export const TournamentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "tournament.v1.TournamentRequest",
  () => [
    { no: 1, name: "tournament", kind: "message", T: Tournament },
    { no: 2, name: "request_state", kind: "enum", T: proto3.getEnumType(TournamentRequestState) },
    { no: 3, name: "requested_by", kind: "message", T: User },
  ],
);

